import React, { VFC } from 'react';
import styled, { css } from 'styled-components';
import { theme } from '../../utils/theme';
import Typography, { ITranslation } from './Typography';

interface Props extends React.HTMLAttributes<HTMLDivElement>, ITranslation {
  disabled?: boolean;
}

const StyledDiv = styled.div<Props>`
  cursor: pointer;
  display: inline-block;
  padding-bottom: 1px;
  border-bottom: 2px solid
    ${({ disabled }) => (disabled ? 'none' : theme.colors.primary[80])};
  :hover {
    border-bottom: 2px solid ${theme.colors.primary[100]};
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.1;
    `}
`;
const StyledText = styled(Typography)<Props>`
  :hover {
    color: ${theme.colors.primary[100]};
  }
`;

const TeritaryButton: VFC<Props> = ({
  children,
  translateKey,
  translateParams,
  disabled = false,
  ...props
}) => (
  <StyledDiv disabled={disabled} {...props}>
    <StyledText
      translateKey={translateKey}
      translateParams={translateParams}
      variant="button"
      align="center"
      color={theme.colors.primary[80]}
      disabled={disabled}
    >
      {children}
    </StyledText>
  </StyledDiv>
);

export default TeritaryButton;
